var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lab"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33334 3.98617C6.86038 3.90683 6.5 3.4955 6.5 3C6.5 2.44772 6.94772 2 7.5 2H12.5C13.0523 2 13.5 2.44772 13.5 3C13.5 3.4955 13.1396 3.90683 12.6667 3.98617V6.57746L16.3865 14.1588C17.2558 15.9307 15.9661 18.0001 13.9924 18.0001H6.00756C4.03394 18.0001 2.74419 15.9307 3.61354 14.1588L7.33334 6.57746V3.98617ZM9.33334 4V6.80956C9.33334 6.96227 9.29836 7.11295 9.2311 7.25005L7.88183 10H12.1182L10.7689 7.25005C10.7016 7.11295 10.6667 6.96227 10.6667 6.80956V4H9.33334Z",
    fill: "#FBBF24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab);
export default __webpack_public_path__ + "static/media/lab.d741fc4f0d0daa62e8f9703a4f16de32.svg";
export { ForwardRef as ReactComponent };